module.exports = __webpack_public_path__ + "static/media/PlayStoreButton.46c6ca53.svg";